import React, { useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
// Box migrated to UDS
import { Button, ExpandCollapse, TextInput, Divider, Box, StackView, Spacer, Typography } from '@telus-uds/components-web';
import Delete from '@telus-uds/palette-allium/build/web/icons/Delete';
import { useTranslationsContext } from '../../../context/TranslationsContext';

import { Heading } from '../css';

const CustomFeatures = ({ selectedFeatures, setSelectedFeatures }) => {
  const {
    WLS: {
      WIRELESS_ORDER_DETAILS: {
        AdditionalFeatures: {
          Name,
          Price,
          AdditionalFeatures,
          AddFeature,
          AdditionalFeaturesList
        }
      }
    }
  } = useTranslationsContext();

  const [customFeatureName, setCustomFeatureName] = useState();
  const [customFeaturePrice, setCustomFeaturePrice] = useState();
  const customFeatures = selectedFeatures.filter(feature =>
    _.get(feature, 'isCustom', false)
  );

  const addCustomFeature = () => {
    if (customFeatureName && customFeaturePrice) {
      setSelectedFeatures([
        ...selectedFeatures,
        {
          id: uuidv4(),
          name: customFeatureName,
          price: +customFeaturePrice,
          isCustom: true
        }
      ]);
      setCustomFeatureName('');
      setCustomFeaturePrice('');
    }
  };

  const removeCustomFeature = id => {
    const updatedList = selectedFeatures.filter(feature => feature.id !== id);
    setSelectedFeatures(updatedList);
  };
  return (
    <ExpandCollapse maxOpen={1} initialOpen={['features']}>
      {(expandProps) => (
        <ExpandCollapse.Panel
          {...expandProps}
          panelId="features"
          control={<Typography variant={{ size: 'h4' }}>{AdditionalFeatures}</Typography>}
        >
          <StackView space={2}>
            <TextInput
              label={Name}
              value={customFeatureName || ''}
              onChange={(value) => {
                setCustomFeatureName(value);
              }}
            />
            <TextInput
              label={Price}
              value={customFeaturePrice || ''}
              type="number"
              onChange={(value) => {
                setCustomFeaturePrice(value);
              }}
            />
            <Button id="features" onClick={addCustomFeature}>{AddFeature}</Button>
            {customFeatures.length > 0 && (
              <>
                <Divider space={1} variant={{ inverse: true }}/>
                <div className="card">
                  <div className="card-header">
                    <Heading>{AdditionalFeaturesList}</Heading>
                  </div>
                  <ul className="list-group list-group-flush">
                    {customFeatures.map(customFeature => (
                      <li
                        className="list-group-item"
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between'
                        }}
                      >
                        <div style={{ backgroundColor: 'white' }}>
                          {customFeature.name} - ${customFeature.price}
                        </div>
                        <Button
                          icon={Delete}
                          onPress={() => removeCustomFeature(customFeature.id)}
                          accessibilityLabel="Delete"
                          variant={{ text: true }}
                        />
                      </li>
                    ))}
                  </ul>
                </div>
              </>
            )}
          </StackView>
        </ExpandCollapse.Panel>
      )}
    </ExpandCollapse>
  );
};

CustomFeatures.propTypes = {
  selectedFeatures: PropTypes.arrayOf(PropTypes.any).isRequired,
  setSelectedFeatures: PropTypes.func.isRequired
};

export default CustomFeatures;
